import _get from 'lodash/get';
import _set from 'lodash/set';
import _merge from 'lodash/merge';

import { videoFeedTypes, getMlbNative } from 'bdvp-common/src/utils';

import DfpRequestBuilder from '../../utils/DfpRequestBuilder';

const { REEL } = videoFeedTypes;

let player = null;
let isPlayerPaused = null;
let isPrerollAdPlaying = null;

export const unsubscribeFromSubscriptions = (subscriptions) => {

    if(!Array.isArray(subscriptions)) {

        return [];

    }

    const destroyedSubscriptions = [];

    subscriptions.forEach((subscription) => {

        if(subscription.unsubscribe) {

            subscription.unsubscribe();
            destroyedSubscriptions.push(subscription);

        }

    });

    return destroyedSubscriptions;

};

export const buildCustomAdRequest = (originalAdConfig, mediaItem, cuePointVO, isLargeBp, isClubPage, topicId, mbox, entitlement = 'free') => {

    if(
        originalAdConfig === null
        || typeof originalAdConfig !== 'object'
        || mediaItem === null
        || typeof mediaItem !== 'object'
    ) {

        return '';

    }

    const adConfig = { ...originalAdConfig };

    const pageCustParams = _get(adConfig, `${isClubPage ? 'team' : 'vpp'}.cust_params`);
    let custParams = _get(adConfig, 'cust_params', {});

    if(pageCustParams) {

        custParams = _merge({}, custParams, pageCustParams);
        _set(adConfig, 'cust_params', custParams);

    }

    const custParamsPageId = _get(custParams, 'pageid');

    if(topicId) {

        _set(adConfig, 'topicId', topicId);

        if(custParamsPageId) {

            _set(adConfig, 'cust_params.pageid', custParamsPageId.replace('{topic_id}', topicId));

        }

    }

    if(mbox) {

        Object.keys(mbox).forEach(mKey => {

            _set(adConfig, `cust_params.${mKey}`, mbox[mKey]);

        });

    }

    if(mediaItem?.data?.type === REEL) {

        _set(adConfig, 'cust_params.isReel', true);

    }

    const { user = {} } = getMlbNative();
    const { isPremium = false, entitlements = [] } = user;
    const userEntitlements = isPremium ? entitlements.join(',') : 'free';
    _set(adConfig, 'cust_params.entitlement', userEntitlements);

    return DfpRequestBuilder.build(adConfig, mediaItem, cuePointVO, isLargeBp);

};

export const onAdStartedEvent = (adConfig, ad, isLargeBp) => {

    const googleIMA = _get(window, 'google.ima');

    if(
        !googleIMA
        || adConfig === null
        || typeof adConfig !== 'object'
        || ad === null
        || typeof ad !== 'object'
    ) {

        return false;

    }

    const ciuSzs = _get(adConfig, 'ciu_szs', isLargeBp ? '300x250' : '320x50').split(',');

    const selectionCriteria = new googleIMA.CompanionAdSelectionSettings();
    selectionCriteria.resourceType = googleIMA.CompanionAdSelectionSettings.ResourceType.STATIC;
    selectionCriteria.creativeType = googleIMA.CompanionAdSelectionSettings.CreativeType.IMAGE;
    selectionCriteria.sizeCriteria = googleIMA.CompanionAdSelectionSettings.SizeCriteria.IGNORE;

    ciuSzs.forEach((ciuSz) => {

        const ciuSzData = ciuSz.split('x');
        const ciuSzWidth = ciuSzData[0];
        const ciuSzHeight = ciuSzData[1];

        // Get a list of companion ads for an ad slot size and CompanionAdSelectionSettings
        const companionAds = ad.getCompanionAds(ciuSzWidth, ciuSzHeight, selectionCriteria);

        // Grab first companion ad found in list
        const companionAd = _get(companionAds, '[0]');

        // Get HTML content from the companion ad
        const companionAdContent = companionAd ? companionAd.getContent() : '';

        // Get ad slot based on ciu sz
        const adSlotElement = document.querySelector(`.p-ad .ad-responsive-size[data-sizes="[[${ciuSzWidth},${ciuSzHeight}]]"]`);

        if(adSlotElement) {

            // Write the companion ad content to the companion ad slot element.
            adSlotElement.innerHTML = `<div class='companion-ad-wrapper'>${companionAdContent}</div>`;

        }

    });

};

export const setIsPlayerPaused = (isPaused) => {

    isPlayerPaused = isPaused;

    return isPlayerPaused;

};

export const setPlayer = (mediaPlayer) => {

    player = mediaPlayer;

    return player;

};

export const pauseVideoPlayback = () => {

    if(!player?.player?.videoEl) {

        return null;

    }

    if(!isPrerollAdPlaying && !isPlayerPaused) {

        player.pause();

    }

};

export const playVideoPlayback = () => {

    if(!player?.player?.videoEl) {

        return null;

    }

    if(!isPrerollAdPlaying && isPlayerPaused) {

        player.play();

    }

};

export const setIsPrerollAdPlaying = (isPlaying) => {

    isPrerollAdPlaying = isPlaying;

    return isPrerollAdPlaying;

};

export const playClip = (clip, playerWrapper) => {

    if(
        !clip
        || !playerWrapper
        || !playerWrapper.resetPlayback
        || !playerWrapper.playClipWithMetadata
    ) {

        return null;

    }

    playerWrapper.resetPlayback();
    playerWrapper.playClipWithMetadata(clip);

};
